module.exports = __webpack_public_path__ + "img/tugas-news.0f21a2c5.jpg";